var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s)
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { InlineError } from '@guardian/src-user-feedback';
import { Label } from '@guardian/src-label';
import { widthFluid, textArea, errorInput } from './styles';
import { descriptionId, generateSourceId, } from '@guardian/src-foundations/accessibility';
const TextArea = (_a) => {
    var { id, label: labelText, optional, hideLabel, supporting, error, cssOverrides, rows = 3, className, value } = _a, props = __rest(_a, ["id", "label", "optional", "hideLabel", "supporting", "error", "cssOverrides", "rows", "className", "value"]);
    const textAreaId = id || generateSourceId();
    const getClassName = () => {
        const HAS_VALUE_CLASS = 'src-has-value';
        if (className) {
            return `${className}${value ? ` ${HAS_VALUE_CLASS}` : ''}`;
        }
        if (value) {
            return HAS_VALUE_CLASS;
        }
        return undefined;
    };
    return (_jsxs(Label, Object.assign({ text: labelText, supporting: supporting, optional: !!optional, hideLabel: hideLabel }, { children: [error && (_jsx(InlineError, Object.assign({ id: descriptionId(textAreaId) }, { children: error }), void 0)),
            _jsx("textarea", Object.assign({ css: [
                    widthFluid,
                    textArea,
                    error ? errorInput : '',
                    cssOverrides,
                ], id: textAreaId, "aria-required": !optional, "aria-invalid": !!error, "aria-describedby": error ? descriptionId(textAreaId) : '', required: !optional, rows: rows, className: getClassName() }, props), void 0)] }), void 0));
};
export { TextArea };
//# sourceMappingURL=index.js.map
